

















































import { AvaliacaoNps } from '@/models'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'

@Component({})
export default class DialogoDeAvaliacaoNpsNaVenda extends Vue {
	@Prop({ default: null }) avaliacaoNps!: AvaliacaoNps | null

	mostra = false
	dateTimeToPtBrFormat = dateTimeToPtBrFormat

	mostrar() {
		this.mostra = true
	}

	get dataExpiracaoAvaliacao(): string | null {
		if (!this.avaliacaoNps) return null

		const raw =
			(this.avaliacaoNps as any).dataExpiracao ||
			(this.avaliacaoNps as any).dataLimiteResposta ||
			(this.avaliacaoNps as any).dataHoraExpiracao ||
			null

		return raw ? this.dateTimeToPtBrFormat(raw) : null
	}

	get notaGeralAvaliacao(): number | null {
		if (!this.avaliacaoNps || !this.avaliacaoNps.respostas) return null

		const geral = this.avaliacaoNps.respostas.find(
			r => r.tipo === 'Geral' && r.nota !== null && r.nota !== undefined,
		)

		return geral && geral.nota !== null && geral.nota !== undefined
			? geral.nota
			: null
	}

	textoTipoAvaliacao(tipo: string): string {
		const map: Record<string, string> = {
			Geral: 'Avaliação geral',
			Atendimento: 'Atendimento',
			Produto: 'Produto',
			Entrega: 'Entrega',
		}

		return map[tipo] || tipo
	}
}
